import { Kana, NumberIdentity, Version } from "@ascend-ltd/logic-helpers";
import { z } from "zod/v4";
import { TenantPhase } from "./tenant-phase";
const TenantIdSchema = NumberIdentity.schema.brand();
export const TenantId = {
    schema: TenantIdSchema,
    of: (id) => TenantId.schema.parse(id),
};
const TenantSlugSchema = z
    .string()
    .min(1)
    .max(16)
    .regex(/^[^\s\u3000]*$/, "全角・半角スペースは利用できません。")
    .brand();
export const TenantSlug = {
    schema: TenantSlugSchema,
    of: (slug) => TenantSlug.schema.parse(slug),
};
const TenantNameSchema = z
    .object({
    name: z.string().min(1).max(32),
    kana: Kana.schema.and(z.string().min(1).max(32)),
})
    .brand();
export const TenantName = {
    schema: TenantNameSchema,
};
const TenantEntitySchema = z.object({
    id: TenantIdSchema,
    tenantSlug: TenantSlug.schema,
    name: TenantName.schema,
    phase: TenantPhase.schema,
    version: Version.schema,
});
const create = (args) => {
    const values = {
        id: NumberIdentity.generate(),
        phase: TenantPhase.initial(),
        version: Version.initial(),
        ...args,
    };
    return TenantEntitySchema.parse(values);
};
const updatePhase = (args) => {
    const values = {
        ...args,
        phase: TenantPhase.of(args.phase),
    };
    return TenantEntitySchema.parse(values);
};
const createForInitializeScript = (args) => {
    const values = {
        phase: TenantPhase.initial(),
        ...args,
    };
    return TenantEntitySchema.parse(values);
};
export const TenantEntity = {
    schema: TenantEntitySchema,
    reconstruct: (args) => TenantEntity.schema.parse(args),
    create,
    createForInitializeScript,
    updatePhase,
};
//# sourceMappingURL=tenant-entity.js.map